import React from "react";

// Line icons from the approved design. All decorative: the text next to them says the same.
const Icon = ({ size = 24, strokeWidth = 2, viewBox = "0 0 24 24", children }) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const DownloadIcon = () => (
  <Icon size={18} strokeWidth={2.4}>
    <path d="M12 3v12M7 10l5 5 5-5M5 20h14" />
  </Icon>
);

export const BellIcon = () => (
  <Icon size={26}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </Icon>
);

export const BellOffIcon = () => (
  <Icon size={26}>
    <path d="M8.7 3A6 6 0 0 1 18 8c0 2.7.6 4.6 1.3 6M17 17H3s3-2 3-9c0-.8.1-1.5.4-2.2" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    <path d="M2 2l20 20" />
  </Icon>
);

export const CompassIcon = () => (
  <Icon size={28} strokeWidth={1.8}>
    <circle cx="12" cy="12" r="10" />
    <path d="M15.5 8.5l-2 5-5 2 2-5z" />
  </Icon>
);

export const GlobeIcon = () => (
  <Icon size={28} strokeWidth={1.8}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
  </Icon>
);

export const ShareIcon = () => (
  <svg
    width="22"
    height="26"
    viewBox="0 0 22 26"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M11 2v14M6 7l5-5 5 5" />
    <path d="M7 11H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-3" />
  </svg>
);

export const AddIcon = () => (
  <Icon>
    <rect x="3" y="3" width="18" height="18" rx="4" />
    <path d="M12 8v8M8 12h8" />
  </Icon>
);
